import { render, staticRenderFns } from "./UserSettingsResumeSettings.vue?vue&type=template&id=358b5b08&scoped=true&"
import script from "./UserSettingsResumeSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettingsResumeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b5b08",
  null
  
)

export default component.exports